// these must not be changed, for backwards compatibility
/**
 * @private
 */
export const SyncOperation = {
  Create: 'POST',
  Update: 'PUT',
  Delete: 'DELETE'
};



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/sync/sync-operation.js